module.exports = __webpack_public_path__ + "media/images/work-flow-2b84684a478491f7574375ac9ba9a713.png";